<template>
  <div class="main-product__sidebar-help">
    <h4
      class="text-heading-s mt-m"
      v-text="contact.title"
    />
    <p
      v-if="contact.subCopy"
      class="text-body-s-regular mt-xs"
      v-text="contact.subCopy"
    />
    <div class="main-product__sidebar-links mt-xs">
      <a
        v-if="contact.phone"
        class="text-heading-m"
        :href="contactNumber"
        v-text="contact.phone"
      />

      <a
        v-if="contact.buttonUrl && contact.buttonText"
        class="text-heading-m"
        :href="contact.buttonUrl"
        v-text="contact.buttonText"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainProductSidebarContact',
  props: {
    contact: {
      type: Object,
      default: () => ({
        title: '',
        subCopy: '',
        phone: '',
        buttonText: '',
        buttonUrl: '',
      }),
    },
  },
  computed: {
    contactNumber() {
      return `tel:${this.contact.phone}`
    },
  },
}
</script>
